import type { UserResponse } from "@sidegigllc/api/client";
import { redirect } from "@tanstack/react-router";
import { isOnsiteManager } from "./roles";

/** Location-manager-only routes. Onsite managers are redirected to their schedule. */
export const requireLocationManager = (user: UserResponse | undefined, locationId: number): void => {
  if (isOnsiteManager(user, locationId)) throw redirect({ href: `/locations/${locationId}/schedule` });
};
